import React from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { propTypes } from '../../util/types';

import BlackSection from './components/BlackSection/BlackSection';
import ResaleFocusSection from './components/ResaleFocusSection/ResaleFocusSection';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const CustomLandingPageBuilder = ({ pageAssetsData, inProgress, error, fallbackPage, contentReady }) => {
  // If we have page data, inject our Hero section as the first section and remove the original first section
  const modifiedPageData = pageAssetsData
    ? {
        ...pageAssetsData,
        sections: [
          {
            sectionType: 'customResaleFocus',
            sectionId: 'resale-focus-section',
          },
          {
            sectionType: 'customAboutMe',
            sectionId: 'about-me-section',
          },
        ],
      }
    : pageAssetsData;

  // Custom section components to register with the PageBuilder
  const customOptions = {
    sectionComponents: {
      customAboutMe: { component: BlackSection },
      customResaleFocus: { component: ResaleFocusSection },
    },
  };

  return (
    <PageBuilder
      pageAssetsData={modifiedPageData}
      inProgress={inProgress}
      error={error}
      fallbackPage={fallbackPage}
      bodyContentReady={contentReady}
      options={customOptions}
    />
  );
};

CustomLandingPageBuilder.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
  fallbackPage: object,
  contentReady: bool,
};

export default CustomLandingPageBuilder;
